import { ConferenceParticipant } from "@regal-voice/shared-types";
import { Tooltip } from "antd";
import { clsx } from "clsx";
import { useSelector } from "react-redux";

import { RVIcon, RVIconSizeOptions } from "@regal-voice/ui";
import { RVTaskStatus } from "Components/shared/RVTaskStatus/RVTaskStatus";
import { selectSnapshotConferenceIsConnected } from "Services/state/conferences/ConferenceSnapshotSelectors";
import { ParticipantInfo } from "Services/state/conferences/ConferenceStateSlice";
import { selectActiveConferenceTask } from "Services/state/conferences/Selectors";

import { useCallActionRecord, useCallTitle, useLineInfo, useNavigateToTask } from "../hooks";
import { useConferenceParticipants } from "../hooks/useConferenceParticipants/useConferenceParticipants";

import styles from "../CallBar.module.scss";

export type CallTaskInfoProps = {
    onInfoUnavailable?: () => void;
};
export const CallTaskInfo = ({ onInfoUnavailable }: CallTaskInfoProps): JSX.Element => {
    const task = useSelector(selectActiveConferenceTask);
    const { contactParticipant } = useConferenceParticipants({ task });
    const navigateToTask = useNavigateToTask({ task });
    const connected = useSelector(selectSnapshotConferenceIsConnected);
    const { isRecording } = useCallActionRecord();
    const lineInfo = useLineInfo({ task });

    const callTitle = useCallTitle({
        participant: contactParticipant as ConferenceParticipant<"contact"> | ParticipantInfo | undefined,
        task,
    });

    if (!task || !lineInfo) {
        onInfoUnavailable?.();
        return <span className={styles.textTitle}>Information Unavailable</span>;
    }

    return (
        <>
            <span className={clsx(styles.textTitle, styles.titleClassName)}>
                <Tooltip title={callTitle} placement="top">
                    <button type="button" className={styles.textActionTitle} onClick={navigateToTask}>
                        {callTitle}
                    </button>
                </Tooltip>
                {" | "}
                <RVTaskStatus task={task} useBarVariant={true} />
            </span>
            {connected && (
                <span>
                    {isRecording ? (
                        <>
                            <RVIcon icon="resume-recording" size={RVIconSizeOptions.XXSMALL} color="red-4" /> Recording
                        </>
                    ) : (
                        "Recording stopped"
                    )}
                </span>
            )}
        </>
    );
};
